import React from 'react';
import { Portal } from 'react-portal';
import Modal from './Modal';

class Contact extends React.PureComponent {
  state = {
    opened: false,
  }

  componentDidMount() {
    window.addEventListener('keydown', this.closeOnEscape);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.closeOnEscape);
  }

  closeOnEscape = (e) => {
    if(e.keyCode === 27) {
      this.closeContact();
    }
  }

  openContact = () => {
    this.setState({ opened: true });
  }

  closeContact = () => {
    this.setState({ opened: false })
  }

  render() {
    const Element = this.props.element;
    return (
      <div className="contact-wrapper">
        <Element onClick={this.openContact} />
        {this.state.opened &&
          <Portal>
            <Modal isOpened={this.state.opened} onClose={this.closeContact}/>
          </Portal>
        }
      </div>
    )
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/index.js